import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { OrganisationDetailsPanelOrganisationFragmentDoc } from './OrganisationDetailsPanelOrganisation.generated'
import * as Types from './purchasePlus_graphql'

export const GetOrganisationSettingsPageHeaderDocument = gql`
  query GetOrganisationSettingsPageHeader($organisationId: Int!) {
    organisation(id: $organisationId) {
      id
      name
      isAPurchaser
      ...OrganisationDetailsPanelOrganisation
    }
  }
  ${OrganisationDetailsPanelOrganisationFragmentDoc}
` as unknown as DocumentNode<
  Types.GetOrganisationSettingsPageHeaderQuery,
  Types.GetOrganisationSettingsPageHeaderQueryVariables
>
